export default function getUrl(url, win = window) {
  if (url.startsWith("http")) {
    return url;
  }

  const origin = getOrigin(win);
  if (origin && origin.indexOf("//gallery.") > -1) {
    return origin.replace("//gallery.", "//www.") + url;
  }

  return url;
}

function getOrigin(win) {
  if (win && win.location && win.location.origin) {
    return win.location.origin;
  }
  return undefined;
}
